/* unplugin-vue-components disabled */import { ElTabs as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/tabs/style/css';
import { ElTabPane as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/tab-pane/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f59a176e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "pane-content"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "tools-container"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom-line"
}, null, -1));
const _hoisted_5 = {
  class: "tools"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
  key: 0,
  class: "card-box-container"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "desc"
};
const _hoisted_13 = {
  key: 0,
  class: "tips"
};
const _hoisted_14 = {
  key: 1,
  class: "empty-channel-list"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "目前没有配置渠道，请前往", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "进行配置", -1));
import { UseToolTabs } from './hooks';
import allPng from '@ultra/share/assets/images/all.png';
import { useAppStore } from '@/store/modules/app';
import { disabledInternal } from './hooks';
import { apiUsdkGetChannelConfigList } from '@/api/usdk';
import router from '@/router';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const appStore = useAppStore();
    const {
      currentTool,
      toolTabs,
      handleFilter,
      items
    } = UseToolTabs();
    const isShowInternal = computed(() => {
      return function (item) {
        if (disabledInternal.includes(process.env.VUE_APP_PLAT) && item.name === 'gsBind') {
          return false;
        }
        return true;
      };
    });
    const editableTabsValue = ref('all');
    const editableTabs = ref([]);
    const handleClick = item => {
      console.log({
        item
      });
      const index = editableTabs.value.findIndex(t => t.name === item.name);
      if (index === -1) {
        editableTabs.value.push(item);
      }
      editableTabsValue.value = item.name;
    };
    const removeTab = targetName => {
      const tabs = editableTabs.value;
      let activeName = editableTabsValue.value;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            const nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            } else {
              activeName = 'all';
            }
          }
        });
      }
      editableTabsValue.value = activeName;
      editableTabs.value = tabs.filter(tab => tab.name !== targetName);
    };
    const isEmptyChannelList = ref(true);
    const getChannelList = async () => {
      const res = await apiUsdkGetChannelConfigList({
        active: '1',
        gid: appStore.gameInfo.Id
      });
      if (res.code === 0) {
        if (res.data.length === 0) {
          isEmptyChannelList.value = true;
        } else {
          isEmptyChannelList.value = false;
        }
      }
    };
    const handleToChannelConfig = () => {
      router.push({
        path: '/pack/channel'
      });
    };
    watch(() => appStore.gameInfo.Id, val => {
      if (val) {
        getChannelList();
      }
    }, {
      immediate: true
    });
    watch(() => editableTabsValue.value, val => {
      appStore.commentKey = val;
      if (val === 'all') {
        appStore.commentKey = 'Operate';
      }
    });
    // 切换游戏类型，重置状态
    watch(() => appStore.gameType, val => {
      editableTabsValue.value = 'all';
      editableTabs.value = [];
    });
    return (_ctx, _cache) => {
      const _component_el_tab_pane = __unplugin_components_0;
      const _component_el_tabs = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_tabs, {
        class: "custom-tab",
        modelValue: _unref(editableTabsValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(editableTabsValue) ? editableTabsValue.value = $event : null),
        type: "card",
        onTabRemove: removeTab
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tab_pane, {
          name: "all"
        }, {
          label: _withCtx(() => [_createElementVNode("img", {
            style: {
              "width": "16px"
            },
            src: _unref(allPng),
            alt: ""
          }, null, 8, _hoisted_2)]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toolTabs), item => {
            return _openBlock(), _createElementBlock("li", {
              onClick: $event => _unref(handleFilter)(item),
              class: _normalizeClass(['tool', _unref(currentTool) === item.value ? 'active' : '']),
              key: item.value
            }, _toDisplayString(item.label), 11, _hoisted_6);
          }), 128))])]), !_unref(isEmptyChannelList) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), item => {
            return _openBlock(), _createElementBlock("div", {
              class: "card-box marginT20",
              key: item.value
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, t => {
              return _openBlock(), _createElementBlock(_Fragment, {
                key: t.name
              }, [_unref(isShowInternal)(t) ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "card-item",
                onClick: $event => handleClick(t)
              }, [_createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
                class: "img",
                src: t.imgSrc,
                alt: ""
              }, null, 8, _hoisted_10), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, _toDisplayString(t.title), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(t.desc), 1)]), t.title === '实名管理' ? (_openBlock(), _createElementBlock("div", _hoisted_13, "已默认配置")) : _createCommentVNode("", true)])], 8, _hoisted_8)) : _createCommentVNode("", true)], 64);
            }), 128))]);
          }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", {
            class: "to-channel",
            onClick: handleToChannelConfig
          }, "渠道列表"), _hoisted_16]))]),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), item => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            closable: "",
            key: item.name,
            label: item.title,
            name: item.name
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.component)))]),
            _: 2
          }, 1032, ["label", "name"]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});